const isEmpty = (field, value) => {
  if (field.type === 'boolean') return value !== true && value !== false;
  if (field.type === 'multiselect') return !Array.isArray(value) || value.length === 0;
  if (value == null) return true;
  if (typeof value === 'string') return value.trim() === '';
  return false;
};

const validateField = (field, value) => {
  if (field.required && isEmpty(field, value)) {
    return 'Ovo polje je obavezno.';
  }

  if (value == null) return null;

  if (field.type === 'number' || field.type === 'rating') {
    if (field.min != null && value < field.min) return `Minimalna vrednost je ${field.min}.`;
    if (field.max != null && value > field.max) return `Maksimalna vrednost je ${field.max}.`;
  }

  if (field.type === 'multiselect' && field.maxSelect != null && Array.isArray(value) && value.length > field.maxSelect) {
    return `Moguće je izabrati najviše ${field.maxSelect}.`;
  }

  return null;
};

const validateRepeatableRows = (field, rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i] || {};
    const missing = field.itemFields.filter(
      (itemField) => itemField.required && isEmpty(itemField, row[itemField.key])
    );
    if (missing.length > 0) {
      const labels = missing.map((f) => f.label).join(', ');
      return `Red ${i + 1}: nedostaje - ${labels}.`;
    }
  }

  return null;
};

// Returns a { [fieldKey]: errorMessage } map for every currently-visible field
// in fieldConfig that fails its required/bounds check against draft.
export const validateSection = (fieldConfig, draft) => {
  const errors = {};

  fieldConfig.forEach((field) => {
    const visible = field.visibleIf ? field.visibleIf(draft) : true;
    if (!visible) return;

    const error =
      field.type === 'repeatable'
        ? validateRepeatableRows(field, draft[field.key])
        : validateField(field, draft[field.key]);

    if (error) errors[field.key] = error;
  });

  return errors;
};
